import { render, staticRenderFns } from "./fePlainText.vue?vue&type=template&id=29d50bd4&"
import script from "./fePlainText.vue?vue&type=script&lang=js&"
export * from "./fePlainText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports